export { default as TabTypes } from './TabTypes';
export { default as Room } from './Room';



// WEBPACK FOOTER //
// ./src/Model/index.js